import { createContext, useContext } from 'react'

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: action.payload
      }
    case 'SET_CATALOG_ARTWORKS_LIST':
      return {
        ...state,
        catalogArtworksList: action.payload
      }
    case 'SET_IS_LOADING_LIST':
      return {
        ...state,
        isLoadingList: action.payload
      }
    case 'SET_IS_LOADING_MORE_ITEM':
      return {
        ...state,
        isLoadingNewpage: action.payload
      }
    case 'SET_LIST':
      return {
        ...state,
        list: action.payload
      }
    case 'SET_LABELS':
      return {
        ...state,
        labels: action.payload
      }
    case 'SET_GALLERY_PROFILE_DATA':
      return {
        ...state,
        galleryProfileData: action.payload
      }
    default:
      return { ...state }
  }
}

export const initialState = {
  CMSProps: null,
  isLoadingList: false,
  isLoadingNewpage: false,
  catalogArtworksList: [],
  activeTab: 'overview',
  labels: {},
  galleryProfileData: null,
  state: {
    list: []
  }
}

type StateType = {
  list: Array<ABTypes.Monolith.ArtworkDetail>
  catalogArtworksList: Array<ABTypes.Monolith.ArtworkDetail>
  isLoadingNewpage: boolean
  activeTab: string,
  galleryProfileData?: {
    id: number
    displayName: string
    cleanTitle: string
  }
  labels: {
    [key: string]: string
  },
  isLoadingList: boolean
  CMSProps: {
    [key: string]: string
  }
}

export const StateContext = createContext<{
  state: StateType
  refs: any
  dispatch: React.Dispatch<any>
}>({
  state: {
    list: [],
    labels: {},
    catalogArtworksList: [],
    galleryProfileData: {
      id: 0,
      displayName: '',
      cleanTitle: ''
    },
    activeTab: 'overview',
    isLoadingNewpage: false,
    isLoadingList: false,
    CMSProps: {}
  },
  refs: {},
  dispatch: () => null
})

export const useModuleContext = () => useContext(StateContext)
